import { useParams, useSearchParams, Link } from 'react-router-dom';
import { makeStyles, tokens } from '@fluentui/react-components';
import { useApi } from '../api/context';
import { useAsync } from '../api/useAsync';
import { Page, PageHeader, Card, Loading, ErrorState } from '../components/common';
import { FindingList } from '../components/FindingList';

const useStyles = makeStyles({
  back: { color: tokens.colorBrandForeground1, textDecorationLine: 'none', fontSize: tokens.fontSizeBase200 },
});

/**
 * Every finding from one collection, unfiltered by pillar. The pillar pages are
 * the usual way in; this is for reading a run end to end.
 */
export function RunFindings() {
  const styles = useStyles();
  const api = useApi();
  const { runId } = useParams<{ runId: string }>();
  const [params] = useSearchParams();
  const tenantId = params.get('tenantId') ?? '';

  const findings = useAsync(
    () => (runId ? api.getFindings(runId) : Promise.resolve([])),
    [runId],
  );

  if (!runId) return <ErrorState error="No run specified." title="Not found" />;
  if (findings.loading) return <Loading label="Loading findings" />;
  if (findings.error) return <ErrorState error={findings.error} />;

  const all = findings.data ?? [];

  return (
    <Page>
      {tenantId && <Link to={`/tenants/${tenantId}`} className={styles.back}>Back to customer</Link>}
      <PageHeader
        title="All findings"
        description={`${all.length} finding${all.length === 1 ? '' : 's'} from this collection, across every pillar.`}
      />
      <Card>
        <FindingList findings={all} tenantId={tenantId} />
      </Card>
    </Page>
  );
}
